import {Fancybox} from "@fancyapps/ui";

document.addEventListener('DOMContentLoaded', function () {
    const galleries = document.querySelectorAll('.wp-block-gallery');
    const shortcode_galleries = document.querySelectorAll('.post-content .gallery');

    if (galleries) {
        galleries.forEach((gallery, index) => {
            const gallery_nr = index + 1;
            const itemsToWrap = gallery.querySelectorAll('[class^="wp-block-image"]');

            itemsToWrap.forEach(item => {
                item.setAttribute('data-fancybox', 'gallery-' + gallery_nr);
                const img_element = item.querySelector('img');

                if (img_element) {
                    const href = img_element.getAttribute('src');

                    item.setAttribute('data-src', href);
                }
            });
        });
    }

    if (shortcode_galleries) {
        shortcode_galleries.forEach((gallery, index) => {
            const gallery_nr = index + 1;
            const itemsToWrap = gallery.querySelectorAll('[class^="gallery-item"]');

            itemsToWrap.forEach(item => {
                item.setAttribute('data-fancybox', 'gallery-sc-' + gallery_nr);
                const a_element = item.querySelector('a');

                // if there is an a element get the href to the image
                if (a_element) {
                    const href = a_element.getAttribute('href');

                    item.setAttribute('data-src', href);
                } else {
                    // as a fallback get the img src
                    const img_element = item.querySelector('img');

                    if (img_element) {
                        const href = img_element.getAttribute('src');

                        item.setAttribute('data-src', href);
                    }
                }
            });
        });
    }

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            enabled: false
        },
        Carousel: {
            formatCaption: (_carouselRef, slide) => {
                let caption = slide.triggerEl?.getElementsByTagName('figcaption')[0];
                return caption ? caption.innerHTML : "";
            },
        },
    });
});

